{
  "filter": "Filtro",
  "filters": "Filtros",
  "ok": "OK",
  "cancel": "Cancelar",
  "close": "Cerrar",
  "delete": "Eliminar",
  "update": "Modificar",
  "remove": {
    "user": "Eliminar un usuario"
  },
  "search": "Buscar",
  "back": "Volver",
  "validate": "Validar",
  "save": "Guardar",
  "archive": "Archivo",
  "send": "Enviar",
  "disable": "Inactivo",
  "enable": "Activo",
  "create": {
    "_": "Nuevo",
    "rootCa": "Cargar el root CA"
  },
  "next": "Siguiente",
  "previous": "Anterior",
  "test": {
    "pki": "Probar la conexión"
  },
  "slider": {
    "enable": "Activar la selección",
    "disable": "Desactivar la selección"
  },
  "download": "Descargar",
  "add": "Añadir",
  "import": "Importar",
  "retryLogin": "Volver a intentar identificarse",
  "retryLogout": "Volver a intentar desconectarse",
  "confirm": "Confirmar",
  "deactivate": "Desactivar",
  "activate": "Activar",
  "upload": "Cargar",
  "copied": "Copiado",
  "copiedTitle": "Copiar al portapapeles",
  "edit": "Modificar"
}
